<template>
  <div class="div_header">
    <div class="layout">
      <!-- <div class="header_logo">
				<img src="@/assets/todoCenter/default/images/header_logo.png" />
				<span v-if="pageName!='gl'">
					<img src="@/assets/todoCenter/default/images/header_apps.png" @click="toApps()" class="header_wz" :class="pageName=='index'?'active':''" />
				</span>
			</div> -->
      <div class="header_login_info" v-if="oidcUser">
        <span>{{ Name }}，你好!</span
        ><a href="javascript:;" @click="signOutOidc" class="logout">退出</a>
      </div>
      <ul class="header_nav">
        <li>
          <router-link to="/workflow/index" tag="a" active-class="active"
            >网站首页</router-link
          >
        </li>
        <li>
          <router-link to="/workflow/appall" tag="a" active-class="active"
            >服务中心</router-link
          >
        </li>
        <li>
          <router-link to="/workflow/approval" tag="a" active-class="active"
            >个人中心</router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "",
  data() {
    return {
      userName: "",
      account: "",
      pageName: "",
    };
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
        Name() {
      return this.$store.getters.getUserInfo.name;
    },
  },
  created() {
    //   console.log(this.$route);
    this.pageName = this.$route.name;
  },
  methods: {
    ...mapActions("oidcStore", ["signOutOidc"]),
    toTodo: function () {
      var href = "#/workflow/todo";
      location.href = href;
    },
    toApps: function () {
      var href = "#/workflow/index";
      location.href = href;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/Header.vue